// Module
var code = "<div class=\"Settings\"> <h2 class=\"Settings__title\">Settings</h2> <div class=\"Settings__container\"> <div class=\"Settings__nav\" ng-class=\"{'Settings__nav--hidden': Settings.isEdit}\" ui-view=\"settingsNav\"></div> <div class=\"Settings__content\"> <div class=\"Settings__overview\" ui-view=\"overview\"></div> <div ui-view=\"edit\"></div> </div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/settings/settings.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;